var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignUpSuccessfulCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F47735",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.271 28.03c-.91-1.007-2.48-1.091-3.472-.168-.992.924-1.075 2.52-.166 3.527L28.118 45.16c.496.504 1.075.84 1.736.84h.083c.661 0 1.323-.252 1.736-.756l31.583-31.993c.992-1.007.992-2.603 0-3.526-.992-.924-2.563-1.008-3.473 0L30.02 39.87 19.271 28.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.513 30.513c-1.41 0-2.488 1.077-2.488 2.487 0 15.422-12.603 28.025-28.025 28.025C17.578 61.025 4.975 48.422 4.975 33 4.975 17.578 17.578 4.975 33 4.975c1.41 0 2.487-1.078 2.487-2.488S34.41 0 33 0C14.842 0 0 14.842 0 33s14.842 33 33 33 33-14.842 33-33c0-1.41-1.078-2.487-2.487-2.487z"
  }))));
}

export default SvgSignUpSuccessfulCheck;